import {
  loginWithPassword
} from "./chunk-DQDOOV4R.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/auth/login.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useLogin = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: loginWithPassword,
    onSuccess: (user) => {
      queryClient.setQueryData(["user", { lang }], __spreadValues({}, user.user));
    }
  });
};

export {
  useLogin
};
//# sourceMappingURL=chunk-6CHSVKNM.mjs.map